<template>
  <v-form>
    <v-container>
      <v-layout>
        <div class="decretosBoton">
          <v-menu bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" small tile outline color="primary">
                <v-icon dark>keyboard_arrow_down</v-icon>&nbsp;Asistencia
              </v-btn>
            </template>
            <v-card class="px-2 py-1">
              <v-card-text class="black--text body-2">
                <v-icon small color="info">info</v-icon>&nbsp;
                <span>
                  <b>Artículo 33 de la Ley 004 Ley de Lucha contra la Corrupción, Enriquecimiento Ilícito e Investigación de Fortunas "</b>
                  ...(Falsedad en la Declaración Jurada de Bienes y Rentas). El que falseare u omitiere insertar los datos económicos, financieros o patrimoniales, que la Declaración Jurada de Bienes y Rentas debá contener, incurrirá en privación de libertad de uno a cuatro años y multa de cincuenta a doscientos días..."
                </span>
                <br />
                <v-icon small color="info">info</v-icon>&nbsp;
                <span>Debe registrar los bienes (en Bolivia o en el Extranjero) en usufructo que son de propiedad de terceros pero su uso o renta generada benefician al declarante.</span>
              </v-card-text>
            </v-card>
          </v-menu>
        </div>
        <v-flex xs12 md12 class="decretos">
          <alert-extendible
            texto='<b>Artículo 33 de la Ley 004 Ley de Lucha contra la Corrupción, Enriquecimiento Ilícito e Investigación de Fortunas "</b>
            ...(Falsedad en la Declaración Jurada de Bienes y Rentas). El que falseare u omitiere insertar los datos económicos, financieros o patrimoniales, que la Declaración Jurada de Bienes y Rentas debá contener, incurrirá en privación de libertad de uno a cuatro años y multa de cincuenta a doscientos días..."'
          ></alert-extendible>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12 md12 class="decretos">
          <alert-extendible
            texto='Debe registrar los bienes (en Bolivia o en el Extranjero) en usufructo que son de propiedad de terceros pero su uso o renta generada benefician al declarante.'
          ></alert-extendible>
        </v-flex>
      </v-layout>
      <v-layout justify-end>
        <v-btn color="success" dark @click.stop="dialog = true" v-show="nro < 4">
          <v-icon>add</v-icon>&nbsp;Adicionar
        </v-btn>
      </v-layout>
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-dialog v-model="dialog" scrollable :max-width="deleteMode?600:1200" persistent>
          <v-card>
            <v-toolbar dark color="primary" right>
              <v-toolbar-title>
                <h4>Bienes Ajenos en Usufructo</h4>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon dark @click="cancel()">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <div class="decretosBoton">
                    <v-menu bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn v-on="on" small tile outline color="primary">
                          <v-icon dark>keyboard_arrow_down</v-icon>&nbsp;Asistencia
                        </v-btn>
                      </template>
                      <v-card class="px-2 py-1">
                        <v-card-text class="black--text body-2">
                          <v-icon small color="info">info</v-icon>&nbsp;
                          <span>Debe registrar los bienes (en Bolivia o en el Extranjero) en usufructo que son de propiedad de terceros pero su uso o renta generada benefician al declarante.</span>
                          <br />
                          <v-icon small color="info">info</v-icon>&nbsp;
                          <span>
                            <b>Rentas Generadas en Bs.:</b>
                            Si el bien genera rentas, debe detallar el importe en moneda nacional de dicha renta. 
                            <br />
                            <b>Descripción, Ubicación, País:</b> Detallar el tipo de bien.
                            Consignar, los datos precisos de ubicación, señalando el país  departamento, provincia, localidad y dirección exacta (Zona, barrio, avenida, calle, piso, departamento, U.V, Manzano. En propiedades rurales que no se tenga la dirección se debe detallar cualquier información referencial que identifique la propiedad. 
                          </span>
                        </v-card-text>
                      </v-card>
                    </v-menu>
                  </div>
                  <v-flex xs12 md12 class="decretos">
                    <alert-extendible
                      v-if="!deleteMode"
                      texto='Debe registrar los bienes (en Bolivia o en el Extranjero) en usufructo que son de propiedad de terceros pero su uso o renta generada benefician al declarante.'
                    ></alert-extendible>
                  </v-flex>
                  <v-flex xs12 md12 class="decretos">
                    <alert-extendible
                      v-if="!deleteMode"
                      texto="<b>Rentas Generadas en Bs.:</b> 
                      Si el bien genera rentas, debe detallar el importe en moneda nacional de dicha renta. 
                      <br><b>Descripción, Ubicación, País:</b> Detallar el tipo de bien.
                      Consignar, los datos precisos de ubicación, señalando el país  departamento, provincia, localidad y dirección exacta (Zona, barrio, avenida, calle, piso, departamento, U.V, Manzano. En propiedades rurales que no se tenga la dirección se debe detallar cualquier información referencial que identifique la propiedad."
                    ></alert-extendible>
                  </v-flex>
                  <v-flex xs12>
                    <v-alert
                      :value="true"
                      type="warning"
                      v-show="deleteMode"
                      outline
                    >¿Está seguro de eliminar el bien ajeno en usufructo siguiente?</v-alert>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex xs12 sm12 md12>
                    <v-layout align-center>
                      <card-tool-tip prepend-icon="help_outline" :icon-color="'primary'">
                        <template v-slot:contenido>
                          <span>
                            <b>Ayuda y Asistencia</b>
                          </span>
                          <br />
                          <v-divider color="primary" class="my-2" />
                          <span>RENTAS GENERADAS EN BS. Señalar el monto en Bolivianos percibido por rentas generadas por el bien si corresponde. El valor debe ser expresado en moneda nacional (Bs) sin decimales, para convertir monedas extranjeras a moneda nacional aplicará el tipo de cambio vigente al momento de la Declaración, según Tabla de Cotizaciones publicada por el Banco Central de Bolivia.</span>
                        </template>
                      </card-tool-tip>&nbsp;
                      <v-currency-field
                        v-bind="currency_config"
                        v-model="rentasBien"
                        :rules="numbersRules"
                        label="Rentas Generadas en Bs.*"
                        required
                        :disabled="deleteMode"
                      ></v-currency-field>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex xs12 sm12 md12>
                    <v-tooltip color="secondary" top>
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="descripcion"
                          :rules="textRules"
                          label="Descripcion, Ubicación, País*"
                          required
                          v-on="on"
                          maxlength="300"
                          :disabled="deleteMode"
                        ></v-text-field>
                      </template>
                      <span>Descripción, Ubicación, País: Detallar el tipo de bien. Consignar, los datos precisos de ubicación, señalando el país  departamento, provincia, localidad y dirección exacta (Zona, barrio, avenida, calle, piso, departamento, U.V, Manzano. En propiedades rurales que no se tenga la dirección se debe detallar cualquier información referencial que identifique la propiedad.</span>
                    </v-tooltip>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex xs12 sm12 md12>
                    <v-tooltip color="secondary" top>
                      <template v-slot:activator="{ on }">
                        <v-textarea
                          @change="observaciones = $util.sanitiza(observaciones)"
                          v-model="observaciones"
                          label="Observaciones"
                          maxlength="250"
                          :rules="$validate(['text_area'])"
                          :disabled="deleteMode"
                          v-on="on"
                          counter
                          hint="Máximo 250 caracteres."
                          persistent-hint
                          rows="1"
                          auto-grow
                        ></v-textarea>
                      </template>
                      <span>Detallar cualquier aclaración que el declarante considere pertinente, respecto a los datos de los Bienes sujetos a usufructo.</span>
                    </v-tooltip>
                  </v-flex>
                  <!--popup-->
                </v-layout>
                <br />
                <v-layout wrap>
                  <v-flex sm12 md12>
                    <v-subheader>
                      <p class="plomo--text">Por favor llene los campos requeridos*</p>
                    </v-subheader>
                  </v-flex>
                </v-layout>
              </v-container>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" :loading="loadingButton" @click="preVerificacion()">
                  <div v-if="deleteMode === true"><v-icon>delete</v-icon>&nbsp;Eliminar</div>
                  <div v-else><v-icon>save</v-icon>&nbsp;Guardar</div>
                </v-btn>
                <v-btn color="error" @click="cancel()"><v-icon>cancel</v-icon>&nbsp;Cancelar</v-btn>
              </v-card-actions>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-form>
      <v-layout wrap>
        <v-flex xs12 md12>
          <v-alert
            class="tamanioBoton"
            v-show="!habilitarLista"
            :value="true"
            color="info"
            icon="info"
          >NO EXISTE NINGUNA INFORMACIÓN REGISTRADA</v-alert>
        </v-flex>
        <v-flex v-show="habilitarLista">
          <v-data-table
            :headers="headers"
            :items="datos"
            class="elevation-1"
            rows-per-page-text="Filas por página"
            :rows-per-page-items="rowsPerPageItems"
          >
            <template slot="items" slot-scope="props" class="justify-center layout px-0">
              <td>{{ props.item.nro }}</td>
              <td>
                <v-tooltip top color="blue">
                  <template v-slot:activator="{ on }">
                    <v-btn icon class="mx-0" @click="editItem(props.item)" v-on="on">
                      <v-icon color="blue">edit</v-icon>
                    </v-btn>
                  </template>
                  <span>Editar</span>
                </v-tooltip>
                <v-tooltip top color="red">
                  <template v-slot:activator="{ on }">
                    <v-btn icon class="mx-0" @click="deleteItem(props.item)" v-on="on">
                      <v-icon color="red">delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Eliminar</span>
                </v-tooltip>
              </td>
              <td>{{ formatPrice(props.item.bie_rentas_generadas) }}</td>
              <td>{{ props.item.bie_descripcion_ubicacion }}</td>
              <td><text-extendible :texto='props.item.bie_observacion'></text-extendible></td>
            </template>
            <template
              v-slot:pageText="props"
            >{{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}</template>
          </v-data-table>
        </v-flex>
      </v-layout>
      <v-layout row justify-center>
        <v-dialog v-model="repetidosModal" scrollable persistent max-width="350">
          <v-card>
            <v-card-title>
              <h4>
                <v-icon color="yellow">warning</v-icon>Advertencia
              </h4>
            </v-card-title>
            <v-card-text>Intenta agregar o actualizar información que se registró anteriormente, el registro o actualización es responsabilidad del declarante.</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                class="tamanioBoton"
                color="primary"
                flat
                @click="repetidosModal = false, guardar()"
              ><v-icon>save</v-icon>&nbsp;Agregar de todos modos</v-btn>
              <v-btn
                class="tamanioBoton"
                color="error"
                flat
                @click="repetidosModal = false, cancel()"
              ><v-icon>cancel</v-icon>&nbsp;Descartar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-container>
  </v-form>
</template>
<script>
import validate from '@/common/mixins/validate';
import jsonQuery from 'json-query';
export default {
  mixins: [ validate ],
  data: () => ({
    loadingButton: false,
    // **codPersona: 1,
    // **codDeclaracion: '1_1',
    codBien: 0,
    listaTipoBien: 3, // TiposBien 3 {3}

    headers: [
      { text: 'Nro', sortable: false, value: 'nro' },
      { text: 'Acciones', sortable: false, value: 'acciones' },
      { text: 'Rentas Generadas en Bs.', sortable: false, value: 'rentasBien' }, //
      { text: 'Descripción', sortable: false, value: 'descripcion' }, //
      { text: 'Observaciones', sortable: false, value: 'observaciones' }
    ],
    datos: [],
    descripcion: '',
    rentasBien: 0,
    observaciones: '',
    mask: '######',
    nro: 1,

    dialog: false,
    menu1: false,
    menu2: false,
    rowsPerPageItems: [5, 10, 25, {'text': 'Todo', 'value': -1}],
    editMode: false,
    deleteMode: false,
    cod_error: null,
    msg_error: null,
    status_error: null,
    dRules: [v => !!v || 'Este campo es requerido'],
    textRules: [v => !!v || 'Este campo es requerido', v => /^[a-zA-Z0-9-_/.*()"“”,.;:=#°ºñÑÁáÉéÍíóÓúÚäÄëËïÏöÖüÜ ]+$/.test(v) || 'Carácter especial no permitido'],
    numbersRules: [v => !!v || 'Este campo es requerido y debe ser un monto en Bolivianos',
      v => v.length < 11 || 'El valor solo puede tener máximo 8 números'],
    currency_config: {
      thousands: '.',
      decimal: ',',
      prefix: 'Bs.',
      precision: 0,
      masked: false,
      allowBlank: true
    },
    valid: true,
    habilitarLista: false,
    repetidosModal: false
  }),
  methods: {
    save () {
      let params = {
        ubicacion: this.descripcion,
        rentas_generadas: this.rentasBien,
        observacion: this.observaciones
      };
      this.$service
        .post(`djbr_registro/bienes_usufructo`, params)
        .then(response => {
          if (response) {
            if (response.err_codigo === 0) {
              this.loadingButton = false;
              this.editMode = false;
              this.dialog = false;
              this.reinicializa();
              this.obtenerBienes();
              this.$message['success'](response.err_mensaje);
            } else {
              this.$message['warning'](response.err_mensaje);
              this.loadingButton = false;
            }
          } else {
            this.loadingButton = false;
          }
        })
        .catch(e => {
          console.log(e);
          this.loadingButton = false;
        });
    },
    update () {
      let params = {
        cod_bien: this.codBien,
        ubicacion: this.descripcion,
        rentas_generadas: this.rentasBien,
        observacion: this.observaciones
      };
      this.$service
        .put(`djbr_registro/bienes_usufructo`, params)
        .then(response => {
          if (response) {
            if (response.err_codigo === 0) {
              this.loadingButton = false;
              this.reinicializa();
              this.obtenerBienes();
              this.editMode = false;
              this.dialog = false;
              this.$message['success'](response.err_mensaje);
            } else {
              this.$message['warning'](response.err_mensaje);
              this.loadingButton = false;
            }
          } else {
            this.loadingButton = false;
          }
        })
        .catch(e => {
          console.log(e);
          this.loadingButton = false;
        });
    },
    delete () {
      this.$service
        .delete(`djbr_registro/bienes/${this.codBien}`)
        .then(response => {
          if (response) {
            if (response.err_codigo === 0) {
              this.loadingButton = false;
              this.reinicializa();
              this.obtenerBienes();
              this.deleteMode = false;
              this.dialog = false;
              this.$message['success'](response.err_mensaje);
            } else {
              this.$message['warning'](response.err_mensaje);
              this.loadingButton = false;
            }
          }
        })
        .catch(e => {
          console.log(e);
          this.loadingButton = false;
        });
    },
    obtenerBienes () {
      this.$service
        .get(`djbr_registro/bienes/${this.listaTipoBien}`, {})
        .then(response => {
          if (response.length >= 1 && response[0].bie_codigo !== -1) {
            this.datos = response;
            this.nro = 0;
            for (let i = 0; i < this.datos.length; i++) {
              this.datos[i].nro = ++this.nro;
              this.habilitarLista = true;
            }
          } else {
            this.datos = [];
            this.habilitarLista = false;
          }
        });
    },
    editItem (item) {
      this.cargaData(item);
      this.editMode = true;
      this.dialog = true;
    },
    deleteItem (item) {
      this.cargaData(item);
      this.deleteMode = true;
      this.dialog = true;
      this.$refs.form.resetValidation();
    },
    cancel () {
      this.dialog = false;
      this.editMode = false;
      this.deleteMode = false;
      this.loadingButton = false;
      this.reinicializa();
    },
    preVerificacion () {
      if (this.deleteMode) {
        this.delete();
      } else {
        if (this.$refs.form.validate()) {
          this.loadingButton = true;
          if (this.rentasBien < 0) {
            this.$message['warning']('Por Favor revise las rentas generadas no es válido.');
            this.loadingButton = false;
          } else {
            if (this.verificarRepetidos() && !this.deleteMode) {
              this.repetidosModal = true;
            } else {
              this.guardar();
            }
          }
        } else {
          this.$message['warning']('Por Favor revise los datos requeridos..');
        }
      }
    },
    guardar () {
      if (this.editMode) {
        this.update();
      } else {
        this.save();
      }
    },
    reinicializa () {
      this.codBien = 0;
      this.descripcion = '';
      this.rentasBien = 0;
      this.observaciones = '';
      this.$refs.form.resetValidation();
    },
    cargaData (item) {
      this.codBien = item.bie_codigo;

      this.descripcion = item.bie_descripcion_ubicacion;
      this.rentasBien = item.bie_rentas_generadas.replace('.00', '');
      this.observaciones = item.bie_observacion;
    },
    formatPrice (value) {
      const val = (value / 1).toFixed(2).replace(',', '.').replace('.00', '');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
    verificarRepetidos () {
      let data = { lista: this.datos };
      let comparing = {
        ubicacion: this.descripcion.toUpperCase().trim() || '',
        rentas_generadas: typeof (this.rentasBien) === 'number' ? `${this.rentasBien}.00` : `${this.rentasBien}.00`,
        observacion: this.observaciones.toUpperCase().trim() || ''
      };
      let resultQuery = jsonQuery(`lista[*bie_rentas_generadas=${comparing.rentas_generadas} &
                                   bie_descripcion_ubicacion=${comparing.ubicacion} &
                                   bie_observacion=${comparing.observacion}]`, { data });
      if (this.editMode) {
        return resultQuery.value.length > 1;
      } else {
        return resultQuery.value.length > 0;
      }
    }
  },
  created () {
    if (this.$storage.get('ex') === 1) {
      this.obtenerBienes();
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/bienes/bienesUsufructo.vue